// ─── Cuál período muestra un informe cuando nadie eligió ────────────────────
//
// UNA SOLA REGLA, Y VIVE ACÁ PORQUE LA USAN LOS DOS LADOS: la pantalla de
// Reportes al abrirse y el asistente cuando le preguntan por el trabajo del
// aula sin decirle de cuándo. Si cada uno eligiera por su cuenta, el asistente
// contestaría sobre un período y la persona estaría mirando otro — y los dos
// números serían correctos, que es la peor forma de estar mal.
//
// LA REGLA: el período `open`, y si no hay ninguno, el que empezó más
// recientemente.
//
// POR QUÉ NO ALCANZA `TermRepository.findActive`, que es lo que parecía: filtra
// por `status in ('open','planned')` y DEJA FUERA `in_progress` — o sea deja
// fuera justamente el período que está corriendo. En producción el Ciclo 2026
// está `in_progress`, así que preguntarle al asistente por el trabajo del aula
// respondía «no hay ningún período activo» mientras la pantalla mostraba ese
// mismo período con datos. El nombre del método engaña; la regla de acá no
// depende de él.
export function pickReportingTerm(terms) {
    if (terms.length === 0)
        return null;
    const open = terms.find((t) => t.status === 'open');
    if (open)
        return open;
    return [...terms].sort((a, b) => b.startDate.localeCompare(a.startDate))[0] ?? null;
}
//# sourceMappingURL=reporting-term.js.map